import { FunctionComponent, useContext, useState } from "react";
import FilterTitle from "./FilterTitle";
import styles from "./FilterDropdown.module.css";
import images from "../../../../assets/images/index";
import "react-datepicker/dist/react-datepicker.css";
import { useLazyQuery } from "@apollo/client";
import { GET_LEAGUES_LIST } from "../../../../features/Tickets/api/TicketsQuery";
import { DateFilter, LeagueListMenu, ResetApplyButtons, convertStringToDate, extractLeagues, formatDateWithHyphen, showCustomRange } from "../../../../helper";
import { globalContext } from "../../../../Provider/AppProvider";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

interface FilterDropdownProps {
  activetab : number
  handleCloseFilterDropDownForSold: () => void
}

interface LeagueObjectType{
  l_id: string,
  l_name: string,
}
interface LeaguesList{
    leagues: LeagueObjectType[]
}
const SoldTicketFilterDropdown: FunctionComponent<FilterDropdownProps> = ({activetab,handleCloseFilterDropDownForSold}) => {
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [soldFilterStartDate,setsoldFilterStartDate] = useState<string | null>(null);
  const [soldFilterEndDate, setsoldFilterEndDate] = useState<string | null>(null);
  const [soldFilterStartDateRange,setsoldFilterStartDateRange] = useState<string | null>(null);
  const [soldFilterEndDateRange, setsoldFilterEndDateRange] = useState<string | null>(null);
  const [soldFilterLeagueId,setsoldFilterLeagueId] = useState<string | null>(globalState.soldTicketFilter.leagueId || null);
  const [valueradio, setValueRadio] = useState<string | null>(globalState.soldTicketFilter.paymentStatus ? globalState.soldTicketFilter.paymentStatus : globalState.soldTicketFilter.payoutType ? globalState.soldTicketFilter.payoutType : null);
  const {dropdownIcon} = images;
  const [anchorEl, setAnchorEl] = useState(null);
  const [soldLeague , setsoldLeague] = useState<string>(globalState.soldTicketFilter.leagueName || "")
  const [days, setDays] = useState<string>(globalState.soldTicketFilter.selectedDateValue || "")
  const [startDate, setStartDate] = useState<any>('');
  const [endDate, setEndDate] = useState<any>('');
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const [customRange, setCustomrange] = useState<boolean>(false);

const [leagueslistData,setLeaguesList] = useState<LeaguesList>();

  const [getLeaguesList] = useLazyQuery(GET_LEAGUES_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if(data){
        const extracted_Data = data?.leagues
        ?.filter((item: LeagueObjectType) => !extractLeagues.includes(item?.l_name))
        .map((result:LeagueObjectType) => result);
        setLeaguesList(extracted_Data);
      }
    }
   });

  const handleClickOpenMenu = (e: any) =>{
    setAnchorEl(e.currentTarget);
    getLeaguesList();
  }

  const handleCloseMenu = ()=>{
    setAnchorEl(null);
  }

  const handleChangeValidate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValueRadio(event.target.value);
  };

  const open = Boolean(anchorEl);

  const handleSelectleague = (league: LeagueObjectType) =>{
    setsoldLeague(league?.l_name);
    setsoldFilterLeagueId(league?.l_id);
    setAnchorEl(null)
  }

  const handleCancel = () =>{
    const tempData = {...globalState};
    tempData.soldTicketFilter.isFilter = false;
    tempData.soldTicketFilter.leagueId = null;
    tempData.soldTicketFilter.leagueName = '';
    tempData.soldTicketFilter.paymentStatus = null;
    tempData.soldTicketFilter.payoutType = null;
    tempData.soldTicketFilter.startdate = null;
    tempData.soldTicketFilter.enddate = null;
    tempData.soldTicketFilter.startDateRange = null;
    tempData.soldTicketFilter.endDateRange = null;
    tempData.soldTicketFilter.selectedDateValue = '';
    tempData.soldTicketFilter.isCustomRange = false;
    tempData.soldTicketFilter.clicked = true;

    handleGlobalState(tempData);
    setsoldLeague("")
    setDays("")
    setValueRadio(null);
    setStartDate("");
    setEndDate("");
    setsoldFilterStartDate(null);
    setsoldFilterEndDate(null);
    setsoldFilterStartDateRange(null);
    setsoldFilterEndDateRange(null);
    setsoldFilterLeagueId(null);
    setShowDatePicker(false)
    setCustomrange(false)
  }

  const handleClickDays = (day: string) =>{
    setStartDate('');
    setEndDate('');
    setsoldFilterStartDateRange(null);
    setsoldFilterEndDateRange(null);
    const {startdate,enddate} = convertStringToDate(day);
    setsoldFilterStartDate(startdate);
    setsoldFilterEndDate(enddate);
    setDays(day);
  }

  const soldDatePickerChange = (dates: any) => {
    const [start, end] = dates; 
    setsoldFilterStartDate(null);
    setsoldFilterEndDate(null);
    setsoldFilterStartDateRange(start  && formatDateWithHyphen(start));
    setsoldFilterEndDateRange(end && formatDateWithHyphen(end));
    setStartDate(start);
    setEndDate(end);
    setDays('')
    setCustomrange(false)
  };

  const handleClickListCustomRange = () =>{
    setShowDatePicker(true)
    setDays('')
    setCustomrange(false);
  }

  const handleClickListDatePickerOutside = () =>{
    setShowDatePicker(false)
    setCustomrange(true)
    setDays('')
    if(endDate === null){
      setsoldFilterEndDateRange(startDate && formatDateWithHyphen(startDate));
      setEndDate(startDate)
    }
  }

const showDayTick = () => {
  if(soldFilterStartDateRange && soldFilterEndDateRange){
    return '';
  }else {
    if(days === '' && globalState.soldTicketFilter.selectedDateValue === ''){
      return '';
    }else if(days){
      return days;
    }else if(globalState.soldTicketFilter.selectedDateValue){
      return globalState.soldTicketFilter.selectedDateValue;
    }
  }
}

const showCustomRangeValues = () => {
  if(soldFilterStartDate){
    return '';
  }else {
    if(customRange === false && globalState.soldTicketFilter.isCustomRange === false){
      return;
     }else if(customRange){
       return (<span className={styles.dateformat}>{showCustomRange(startDate,endDate,"sold",globalState)}</span>);
     }else if(globalState.soldTicketFilter.isCustomRange){
       return (<span className={styles.dateformat}>{showCustomRange(startDate,endDate,"sold",globalState)}</span>);
     }
  }
}
const handleSubmitFilter = () => {
  const tempData = {...globalState};
  if(soldFilterLeagueId || soldFilterStartDate || soldFilterStartDateRange || valueradio){
    tempData.soldTicketFilter.isFilter = true;
    tempData.soldTicketFilter.clicked = true;
  }
  if(soldFilterStartDateRange && soldFilterEndDateRange){
    tempData.soldTicketFilter.startdate = null;
    tempData.soldTicketFilter.enddate = null;
    tempData.soldTicketFilter.startDateRange = soldFilterStartDateRange ? soldFilterStartDateRange : globalState.soldTicketFilter.startDateRange;
    tempData.soldTicketFilter.endDateRange = soldFilterEndDateRange ? soldFilterEndDateRange : globalState.soldTicketFilter.endDateRange;
  }else {
    if(days === 'Today' || days === 'Yesterday'){
      tempData.soldTicketFilter.startdate = soldFilterStartDate ? soldFilterStartDate : globalState.soldTicketFilter.startdate;
      tempData.soldTicketFilter.enddate = null;
      tempData.soldTicketFilter.startDateRange = null;
      tempData.soldTicketFilter.endDateRange = null;
    }else {
      if(globalState.soldTicketFilter.startDateRange && globalState.soldTicketFilter.endDateRange){
        if(soldFilterStartDate && soldFilterEndDate){
          tempData.soldTicketFilter.startdate = soldFilterStartDate ? soldFilterStartDate : globalState.soldTicketFilter.startdate;
          tempData.soldTicketFilter.enddate = soldFilterEndDate ? soldFilterEndDate : globalState.soldTicketFilter.enddate;
          tempData.soldTicketFilter.startDateRange = null;
          tempData.soldTicketFilter.endDateRange = null;
        }else {
          tempData.soldTicketFilter.startdate = null;
          tempData.soldTicketFilter.enddate = null;
          tempData.soldTicketFilter.startDateRange = soldFilterStartDateRange ? soldFilterStartDateRange : globalState.soldTicketFilter.startDateRange;
          tempData.soldTicketFilter.endDateRange = soldFilterEndDateRange ? soldFilterEndDateRange : globalState.soldTicketFilter.endDateRange;
        }
      }else {
        tempData.soldTicketFilter.startdate = soldFilterStartDate ? soldFilterStartDate : globalState.soldTicketFilter.startdate;
        tempData.soldTicketFilter.enddate = soldFilterEndDate ? soldFilterEndDate : globalState.soldTicketFilter.enddate;
        tempData.soldTicketFilter.startDateRange = null;
        tempData.soldTicketFilter.endDateRange = null;
      }
    }
  }
  tempData.soldTicketFilter.leagueId = soldFilterLeagueId;
  tempData.soldTicketFilter.leagueName = soldLeague;
  tempData.soldTicketFilter.paymentStatus = valueradio ? valueradio === 'Voided_Payout' ? null : valueradio : null;
  tempData.soldTicketFilter.selectedDateValue = days;
  tempData.soldTicketFilter.payoutType = valueradio === 'Voided_Payout' ? valueradio : 'Unvoided_Payout'
  if(soldFilterStartDateRange && soldFilterEndDateRange){
  tempData.soldTicketFilter.isCustomRange = true;
  }
  handleGlobalState(tempData);
  handleCloseFilterDropDownForSold();
}

  return (
    <div className={styles.filterDropdownSold}>
      <div className={styles.topForSold}>
        <FilterTitle handleCloseFilterDropDown={handleCloseFilterDropDownForSold}/>
        <div className={styles.filterContainersold}>
          <div className={styles.containerInSold}>
            <div className={styles.filterDetailsInSold}>
              <div className={styles.textFieldFullMainInSold}>
                <div className={styles.titlePlaceholderInSold}>
                  <b className={styles.eventTitleStyle}>Event</b>
                </div>
                <div className={styles.textFieldInSold} onClick={handleClickOpenMenu}>
                  <div className={styles.leagueContainerSold}>
                    <div
                      className={
                        soldLeague === "" ? styles.select : styles.leagueSelect
                      }
                    >
                      {soldLeague ? soldLeague : '--Select--'}
                    </div>
                    <img
                      className={styles.sharpOutlineDropdown}
                      alt=""
                      src={dropdownIcon}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.paymentStatus}>
                <div>
                  <b className={styles.paymentStatusSubContainer}>Status</b>
                </div>
                <div
                  className={styles.radiogroup}
                >
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={valueradio}
                    onChange={handleChangeValidate}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div>
                      <FormControlLabel
                        value = 'NotInitiated'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },              
                            }}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioSold}>Sold</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value = 'Inprogress'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },              
                            }}
                            data-testid ={`one`}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioInprogress}>In Progress</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value = 'Success'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              }
                            }}
                            data-testid ={`two`}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioSettled}>Settled</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value = 'Failed'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },              
                            }}
                            data-testid ={`three`}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioFailed}>Failed</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value = 'Voided_Payout'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },              
                            }}
                            data-testid ={`one`}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioVoidedPayout}>Voided Payout</span>
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <DateFilter 
                handleClickDays={handleClickDays}
                showDayTick={showDayTick} 
                handleClickCustomRange={handleClickListCustomRange}
                showCustomRangeValues={showCustomRangeValues} 
                showDatePicker={showDatePicker} 
                startDate={startDate}
                endDate={endDate}
                handleClickOutside={handleClickListDatePickerOutside} 
                onChange={soldDatePickerChange}
              />
            </div>
          </div>
          <ResetApplyButtons handleCancel={handleCancel} handleSubmit= {handleSubmitFilter}/>
        </div>
      </div>
       <LeagueListMenu
        anchorEl ={anchorEl}
        open= {open}
        selectedLeague = {soldLeague}
        handleCloseMenu ={handleCloseMenu}
        handleSelectleague={handleSelectleague}
        leagueslistData = {leagueslistData}
      />
    </div>
  );
};

export default SoldTicketFilterDropdown;
